import React from "react";

interface Props {
  value?: string | number;
  disabled?: boolean;
  isInner?: boolean;
  label?: string;
  options: {
    value: string | number;
    label: string;
  }[];
  onSelect: (e: string | number) => void;
  hasError?: boolean;
  /** Visual chip appended after the options. It does not change the selected value. */
  statusLabel?: string;
}

const FilterTabs: React.FC<Props> = ({
  value,
  options,
  onSelect,
  disabled,
  label,
  isInner,
  hasError,
  statusLabel,
}) => {
  const handleChange = (e: string | number) => {
    onSelect(e);
  };
  const visibleStatusLabel = statusLabel?.trim() ? statusLabel : undefined;

  return (
    <div
      className={`filter-tabs-wrapper
    ${isInner ? "inner" : ""}
    ${label ? "with-label" : ""}
    ${hasError ? "has-error" : ""}
    ${disabled ? "disabled" : ""}
  `}
      aria-disabled={disabled}
    >
      {label && <div className="label">{label}</div>}
      {options.map((el) => (
        <div
          className={`item ${disabled ? "disabled" : ""} ${
            !visibleStatusLabel && el.value === value ? "active" : ""
          }`}
          key={el.value}
          aria-disabled={disabled}
          onClick={() => {
            if (!disabled) handleChange(el.value);
          }}
        >
          {el.label}
        </div>
      ))}
      {visibleStatusLabel && (
        <div className="item active status" aria-hidden="true">
          {visibleStatusLabel}
        </div>
      )}
    </div>
  );
};

export default FilterTabs;
